if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[data-addtocart-main]') || this.querySelector('[data-active="true"] [type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.currentOpt = 'spot';
      this.planHref = null;

      this.querySelectorAll('.trs-opt-card').forEach(card => {
        card.addEventListener('click', () => {
          if (card.hasAttribute('data-disabled')) return;
          this.onCardSelect(card.dataset.opt, card.dataset.variantId, card.dataset.planHref);
        });
      });

      document.addEventListener('change', (e) => {
        if (e.target.tagName !== 'INPUT' || e.target.type !== 'radio') return;
        if (e.target.value === 'スポットレンタル' || e.target.value === 'サブスクプランレンタル') {
          this.onVariantChange({ data: { variant: { option1: e.target.value } } });
        }
      });
    }

    onCardSelect(opt, variantId, planHref) {
      this.currentOpt = opt;
      this.planHref = planHref || null;

      this.querySelectorAll('.trs-opt-card').forEach(card => {
        const selected = card.dataset.opt === opt;
        card.classList.toggle('trs-selected', selected);
        const radio = card.querySelector('.trs-radio');
        if (radio) radio.classList.toggle('trs-radio--on', selected);
      });

      const idInput = this.form.querySelector('[name=id]');
      if (idInput && variantId) idInput.value = variantId;

      const ticketInput = this.form.querySelector('[name="properties[_required_tickets]"]');
      if (ticketInput) ticketInput.disabled = (opt !== 'ticket');

      const btnText = this.querySelector('[data-addtocart-text]');
      const note = this.querySelector('[data-trs-cta-note]');

      if (opt === 'spot') {
        if (btnText) btnText.textContent = 'スポットレンタルする';
        if (note) note.textContent = '決済後、発送日をメールにてご連絡します';
      } else if (opt === 'ticket') {
        if (btnText) btnText.textContent = 'チケットを使ってレンタルする';
        if (note) note.textContent = 'チケット1枚が消費されます';
      } else if (opt === 'plan') {
        if (btnText) btnText.textContent = 'プランに登録してレンタルする';
        if (note) note.textContent = 'プラン登録後、すぐにレンタル可能です';
      }

      const spotSteps = this.querySelector('.trs-howto--spot');
      const ticketSteps = this.querySelector('.trs-howto--ticket');
      if (spotSteps) spotSteps.style.display = opt === 'spot' ? '' : 'none';
      if (ticketSteps) ticketSteps.style.display = opt !== 'spot' ? 'block' : 'none';

      this.submitButton = this.querySelector('[data-addtocart-main]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.currentOpt === 'plan' && this.planHref) {
        window.location = this.planHref;
        return;
      }

      this.submitButton = this.querySelector('[data-addtocart-main]') || this.querySelector('[data-active="true"] [type="submit"]');
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      this.submitButton.querySelector('[data-addtocart-text]')?.classList.add('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if (document.querySelector('#product-quic-kview') && document.querySelector('#product-quic-kview').classList.contains("active")) {
            document.querySelector('#product-quic-kview').classList.remove("active");
          }
          if (this.cart) {
            this.cart.renderContents(response);
            this.cart.classList.add("active");
            let cartItemsElement = this.cart.querySelector(".side-drawer-modal-inner");
            setTimeout(function() {
              focusElement == "" && (focusElement = this.submitButton);
              trapFocusElements(cartItemsElement);
            }, 1500);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('[data-addtocart-text]')?.classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    onVariantChange({ data: { variant } = {} } = {}) {
      if (!variant) return;
      const isSpot = variant.option1 === 'スポットレンタル';
      const subUI = this.querySelector('.rental-ui--subscription');
      const spotUI = this.querySelector('.rental-ui--spot');
      if (subUI) { subUI.style.display = isSpot ? 'none' : ''; subUI.dataset.active = String(!isSpot); }
      if (spotUI) { spotUI.style.display = isSpot ? '' : 'none'; spotUI.dataset.active = String(isSpot); }
      const ticketInput = this.querySelector('[name="properties[_required_tickets]"]');
      if (ticketInput) ticketInput.disabled = isSpot;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}